import { render } from "./LicenseInfoOnPrem.vue?vue&type=template&id=cfd07da8"
import script from "./LicenseInfoOnPrem.vue?vue&type=script&lang=js"
export * from "./LicenseInfoOnPrem.vue?vue&type=script&lang=js"

import "./LicenseInfoOnPrem.vue?vue&type=style&index=0&id=cfd07da8&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__